import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { routeConfig } from './routeConfig';

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        {routeConfig.map(({ element, path }) => (
          <Route key={path} element={element} path={path} />
        ))}
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
